var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dense":"","text":"","color":_vm.color,"border":"left","icon":_vm.icon}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }